/**
 * 新增 修改公用
 */
import utils from 'utils'

class editBuyerCtrl {
    constructor($scope, httpRequest, $state, $stateParams, formvalidateApi, logger, buyerChecker) {
        $scope.isPersonal = false // 纳税人类型是否为'个人'
        $scope.customerCodeIsDisable = true

        function reset() {
            $scope.edit = {
                customerName: '', // 名称
                customerCode: null, // 编号
                creditCode: '', // 信用代码
                bank: '', // 开户银行
                bankAccount: '', // 银行账号
                taxplayerType: '1', // 纳税人类型 默认一般纳税人
                status: 1, // 有效标识 默认有效
                phone: '',
                businessAddress: '', // 地址
                legalName: '', // 联系人
                mobile: '', // 手机
                email: '', // 邮箱
            }
        }

        function init() {
            reset()
            const {
                customerId,
            } = $stateParams
            if (customerId) {
                $scope.isEdit = true
                httpRequest.get_getSysCustomerById(customerId).then((res) => {
                    $scope.edit = res.data.value
                    if (!$scope.edit.phone) {
                        $scope.edit.phone = ''
                    }
                    if (!$scope.edit.businessAddress) {
                        $scope.edit.businessAddress = ''
                    }
                })
            }
        }
        init()
        // 自动编码
        $scope.customerCodeAutoSetting = function customerCodeAutoSetting(val) {
            $scope.customerCodeIsDisable = val
            if (val) {
                $scope.edit.customerCode = null
            }
        }
        $scope.validateRules = {
            customerCode: [{
                erromsg: '购方编码,最少2位字符,最多32位字符',
                condition(value) {
                    if (value === null) {
                        value = ''
                    }
                    // 规则
                    const result = (value.toString().length >= 2 && value.toString().length <= 32)
                    // true 标示显示 errmsg  false 标示验证通过
                    return $scope.customerCodeIsDisable ? false : !result
                },
            }],
            customerName: [{
                erromsg: '购方名称,最少2位字符,最多100位字符',
                condition(value) {
                    // 规则
                    const result = (lengthForString(value.toString()) >= 2 && lengthForString(value.toString()) <= 100)
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }, {
                erromsg: '购方名称,不能以AC开头',
                condition(value) {
                    return (value && value.toUpperCase().indexOf('AC') === 0)
                },
            }],
            creditCode: [{
                erromsg: '纳税人类型为企业时，税号必填',
                condition(value) {
                    return $scope.edit.taxplayerType <= 2 && !value.trim()
                },
            }],
            userPhone: [{
                erromsg: '电话格式错误',
                condition(value) {
                    $scope.edit.businessAddress = $scope.edit.businessAddress || ''
                    if (value) {
                        return !utils.regExpTest(value, 'uglyPhone')
                    }
                    return false
                },
            }],
            // bankAccount: [
            //     {
            //         erromsg: '开户行+开户行账户总长度不能大于100位',
            //         condition(value) {
            //             // 规则
            //             if (value === '' || /^[ ]+$/.test(value)) return false
            //             const result = (100 - value.toString().length - $scope.edit.bank.length > 0)
            //             // true 标示显示 errmsg  false 标示验证通过
            //             return !result
            //         },
            //     },
            //     {
            //         erromsg: '请输入正确的银行账号',
            //         condition(value) {
            //             // 规则
            //             if (value === '' || /^[ ]+$/.test(value)) return false
            //             return !/\d/.test(value)
            //         },
            //     },
            // ],
            bank: [{
                erromsg: '开户行+开户行账户总长度不能大于100个字符',
                condition(value) {
                    // 规则
                    if (!value || /^[ ]+$/.test(value)) return false
                    const result = (100 - value.toString().length > 0)
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }],
            businessAddress: [{
                erromsg: '联系电话+地址总长度不能大于100个字符',
                condition(value) {
                    // 规则
                    // const result = (value == '' | value == null) | (100 - value.toString().length - $scope.edit.phone.toString().length > 0)
                    const result = (value == '' || value == null) || (100 - value.toString().length > 0)
                    // true 标示显示 errmsg  false 标示验证通过
                    return !result
                },
            }],
            email: [{
                erromsg: '请确认邮箱格式是否正确且长度不大于100个字符',
                condition(value) {
                    const result = (value == '' || value == null) || ((100 - value.toString().length > 0) && (utils.regExpTestEmail(value)))
                    return !result
                },
            }],
            mobile: [{
                erromsg: '手机号码格式不正确',
                condition(value) {
                    return value && !utils.regExpTest(value, 'mobile')
                },
            }],
            certificateNo: [{
                erromsg: '身份证/组织机构代码证长度不能大于22个字符',
                condition(value) {
                    const result = (value == '' || value == null) || (22 - value.toString().length > 0)
                    return !result
                },
            }],
            legalName: [{
                erromsg: '联系人长度不能大于100个字符',
                condition(value) {
                    const result = (value == '' || value == null) || (100 - value.toString().length > 0)
                    return !result
                },
            }]

        }
        $scope.upperCase = function () {
            if ($scope.edit.creditCode) {
                $scope.edit.creditCode = $scope.edit.creditCode.toUpperCase()
            }
        }
        const submitHandler = {
            add() {
                httpRequest.post_addSysCustomer($scope.edit, '信息提交成功').then(() => {
                    $state.go('outputManage.ovat.buyer.list')
                })
            },
            continueAdd() {
                httpRequest.post_addSysCustomer($scope.edit, '信息提交成功,继续添加').then(() => {
                    reset()
                })
            },
            edit() {
                httpRequest.post_updateSysCustomer($scope.edit, '购方信息修改成功').then(() => {
                    $state.go('outputManage.ovat.buyer.list')
                })
            },
        }
        // 修改 新增 新增并继续
        $scope.submit = function (method) {
            if ($scope.edit.customerCode && $scope.edit.customerCode.slice(0, 2) == 'AC' && method != 'edit') {
                logger.logError('编号不得以AC开头')
                return
            }
            const mark = formvalidateApi.run()
            if (!mark) {
                return
            }
            // if (!(/^([0-9A-Z]{15}|[0-9A-Z]{17}|[0-9A-Z]{18}|[0-9A-Z]{20})$/.test($scope.edit.creditCode))) {
            //     sweetalert.confirm('操作提醒', ' 购买方纳税人识别号非15、17、18、20位，请确认税号是否正确，是否继续？').then(() => {
            //         submitHandler[method]()
            //     })
            // } else {
            //     submitHandler[method]()
            // }

            buyerChecker.checkBuyerCreditCode($scope.edit.creditCode, $scope.edit.taxplayerType).then(() => {
                submitHandler[method]()
            })

        }
        $scope.cancle = function () {
            $state.go('outputManage.ovat.buyer.list')
        }

        function lengthForString(temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i += 1) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    len += 1
                } else {
                    len += 2
                }
            }
            return len
        }
    }
}
editBuyerCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', 'logger', 'buyerChecker']
export default editBuyerCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/buyer/editBuyerCtrl.js